import { render } from "./MyPackage.vue?vue&type=template&id=210d564c"
import script from "./MyPackage.vue?vue&type=script&lang=js"
export * from "./MyPackage.vue?vue&type=script&lang=js"

import "./MyPackage.vue?vue&type=style&index=0&id=210d564c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__